import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingContact from "@/components/FloatingContact";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import References from "@/pages/References";
import Contact from "@/pages/Contact";
import Impressum from "@/pages/Impressum";
import AGB from "@/pages/AGB";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/leistungen" element={<Services />} />
              <Route path="/leistungen/:slug" element={<ServiceDetail />} />
              <Route path="/ueber-uns" element={<About />} />
              <Route path="/referenzen" element={<References />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Impressum />} />
              <Route path="/agb" element={<AGB />} />
            </Routes>
          </main>
          <Footer />
          <FloatingContact />
          <CookieBanner />
          <Toaster position="bottom-left" theme="light" />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
